import { StateSchema } from 'app/config/storeConfig/types';
import { BookingSteps } from '../types';

export const getMaxProgressStep = (state: StateSchema): BookingSteps => state.bookingHeader.maxProgressStep;
